import { NavCard } from "../../v2024/card"
import { Link } from "gatsby"
import CardPost from "../../v2023/UI/Card/card-post"
import React from "react"

export const SolutionsSectionMobile = ({ menuItem, title, items, stories, openMenuItem, selectOpenMenuItem }) => {
    const handleMenu = () => {
        selectOpenMenuItem(menuItem)
        document.getElementById("menuItem").scrollIntoView({ behavior: "smooth" })
    }

    return (
        <div id="menuItem" className={`item ${openMenuItem === menuItem ? "item--active" : ""}`}>
            <div className="item__header" onClick={() => handleMenu()}>
                <h6 className="item__header__title">{title}</h6>
                <i className="icon-chevron-down"></i>
            </div>
            <div className="item__body">
                {items.map(item =>
                    <div className="mobile__menu__section">
                        <span className="section__title">{item.section_title}</span>
                        {item.section_items.map(element =>
                            <>
                                {element.image ?
                                    <NavCard
                                        title={element.title} link={element.url} size="lg"
                                        icon={element.image} description={element.description}
                                    />
                                    :
                                    <NavCard
                                        title={element.title} link={element.url}
                                        size="sm" description={element.description}
                                    />
                                }
                            </>
                        )}
                        <Link className="section__view-more" to={item.see_all.url}>{item.see_all.text}</Link>
                    </div>
                )}
                <div className="mobile__menu__section mobile__menu__section--gray">
                    <span className="section__title">{stories.title}</span>
                    {stories.customer_card.map(card =>
                        <CardPost
                            name={card.description}
                            image={card.image}
                            horizontal
                            url={card.url}
                            size="xs"
                        />
                    )}
                    <Link className="section__view-more" to={stories.see_all.url}>{stories.see_all.text}</Link>
                </div>
            </div>
        </div>
    )
}